/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../base';
// @ts-ignore
import type { CheckClickCampaignPreparedForbiddenAlreadyCompleteDto } from '../../src/model';
// @ts-ignore
import type { CheckClickCampaignPreparedForbiddenCampaignCompletedDto } from '../../src/model';
// @ts-ignore
import type { CheckClickCampaignPreparedForbiddenCampaignUnavailableDto } from '../../src/model';
// @ts-ignore
import type { CheckClickCampaignPreparedForbiddenCaptchaRequiredDto } from '../../src/model';
// @ts-ignore
import type { CheckClickCampaignPreparedForbiddenCommentBannedDto } from '../../src/model';
// @ts-ignore
import type { CheckClickCampaignPreparedForbiddenUserUnauthorizedDto } from '../../src/model';
// @ts-ignore
import type { CheckClickCampaignPreparedInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { CheckClickCampaignPreparedNotFoundDto } from '../../src/model';
// @ts-ignore
import type { CheckClickCampaignPreparedOkDto } from '../../src/model';
// @ts-ignore
import type { GetCaptchaInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { GetClickCampaignsBadGatewayDto } from '../../src/model';
// @ts-ignore
import type { GetClickCampaignsBadRequestDto } from '../../src/model';
// @ts-ignore
import type { GetClickCampaignsInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { GetClickCampaignsOkDto } from '../../src/model';
// @ts-ignore
import type { GetViewingLockTimeOkResponseDto } from '../../src/model';
// @ts-ignore
import type { JwtAccessGuardUnauthorizedDto } from '../../src/model';
// @ts-ignore
import type { RetrieveViewingPointConflictDto } from '../../src/model';
// @ts-ignore
import type { RetrieveViewingPointForbiddenViewingLogDto } from '../../src/model';
// @ts-ignore
import type { RetrieveViewingPointInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { RetrieveViewingPointNotFoundViewingLogDto } from '../../src/model';
// @ts-ignore
import type { RetrieveViewingPointReqBodyDto } from '../../src/model';
// @ts-ignore
import type { VerifyCaptchaForbiddenDto } from '../../src/model';
// @ts-ignore
import type { VerifyCaptchaReqBodyDto } from '../../src/model';
// @ts-ignore
import type { VerifyClickCampaignBadGatewayDto } from '../../src/model';
// @ts-ignore
import type { VerifyClickCampaignBadRequestDto } from '../../src/model';
// @ts-ignore
import type { VerifyClickCampaignConflictDto } from '../../src/model';
// @ts-ignore
import type { VerifyClickCampaignForbiddenAlreadyCompleteDto } from '../../src/model';
// @ts-ignore
import type { VerifyClickCampaignForbiddenCampaignClosedDto } from '../../src/model';
// @ts-ignore
import type { VerifyClickCampaignForbiddenCampaignRemovedDto } from '../../src/model';
// @ts-ignore
import type { VerifyClickCampaignForbiddenCampaignVerifyFailedDto } from '../../src/model';
// @ts-ignore
import type { VerifyClickCampaignForbiddenCaptionDuplicatedDto } from '../../src/model';
// @ts-ignore
import type { VerifyClickCampaignForbiddenCaptionRequiredDto } from '../../src/model';
// @ts-ignore
import type { VerifyClickCampaignForbiddenCaptionSpamDto } from '../../src/model';
// @ts-ignore
import type { VerifyClickCampaignForbiddenNotVerifiedDto } from '../../src/model';
// @ts-ignore
import type { VerifyClickCampaignForbiddenPlatformUserRequiredDto } from '../../src/model';
// @ts-ignore
import type { VerifyClickCampaignForbiddenShortCaptionDto } from '../../src/model';
// @ts-ignore
import type { VerifyClickCampaignForbiddenUserChallengeRequiredDto } from '../../src/model';
// @ts-ignore
import type { VerifyClickCampaignForbiddenUserFeedbackRequiredDto } from '../../src/model';
// @ts-ignore
import type { VerifyClickCampaignForbiddenUserFollowingLimitedDto } from '../../src/model';
// @ts-ignore
import type { VerifyClickCampaignForbiddenUserUnauthorizedDto } from '../../src/model';
// @ts-ignore
import type { VerifyClickCampaignInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { VerifyClickCampaignNotFoundPointCategoryDto } from '../../src/model';
// @ts-ignore
import type { VerifyClickCampaignNotFoundPointTypeDto } from '../../src/model';
// @ts-ignore
import type { VerifyClickCampaignNotFoundSnsAccountDto } from '../../src/model';
// @ts-ignore
import type { VerifyClickCampaignNotFoundUserDto } from '../../src/model';
// @ts-ignore
import type { VerifyClickCampaignNotFoundViewingTypeDto } from '../../src/model';
// @ts-ignore
import type { VerifyClickCampaignOkDto } from '../../src/model';
// @ts-ignore
import type { VerifyClickCampaignReqBodyDto } from '../../src/model';
// @ts-ignore
import type { ViewingClickCampaignInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { ViewingClickCampaignReqBodyDto } from '../../src/model';
/**
 * ViewingApi - axios parameter creator
 * @export
 */
export const ViewingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 모두그램에서 호출: 자동적립 / 뷰업플러스 뷰잉하기 
         * @param {string} campaignUuid 클릭형 캠페인 uuid
         * @param {ViewingClickCampaignReqBodyDto} viewingClickCampaignReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewingControllerAutoViewingClickCampaign: async (campaignUuid: string, viewingClickCampaignReqBodyDto: ViewingClickCampaignReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignUuid' is not null or undefined
            assertParamExists('viewingControllerAutoViewingClickCampaign', 'campaignUuid', campaignUuid)
            // verify required parameter 'viewingClickCampaignReqBodyDto' is not null or undefined
            assertParamExists('viewingControllerAutoViewingClickCampaign', 'viewingClickCampaignReqBodyDto', viewingClickCampaignReqBodyDto)
            const localVarPath = `/viewing/click/campaigns/{campaignUuid}`
                .replace(`{${"campaignUuid"}}`, encodeURIComponent(String(campaignUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(viewingClickCampaignReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 뷰잉 보안문자 이미지 생성
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewingControllerGetCaptcha: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/viewing/captcha`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 클릭형 캠페인 가져오기
         * @param {Array<ViewingControllerGetClickCampaignsInstagramEnum>} [instagram] 인스타그램 필터링 조건
         * @param {Array<ViewingControllerGetClickCampaignsYoutubeEnum>} [youtube] 유튜브 필터링 조건
         * @param {Array<ViewingControllerGetClickCampaignsFacebookEnum>} [facebook] 페이스북 필터링 조건
         * @param {Array<ViewingControllerGetClickCampaignsThreadsEnum>} [threads] 스레드 필터링 조건
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewingControllerGetClickCampaigns: async (instagram?: Array<ViewingControllerGetClickCampaignsInstagramEnum>, youtube?: Array<ViewingControllerGetClickCampaignsYoutubeEnum>, facebook?: Array<ViewingControllerGetClickCampaignsFacebookEnum>, threads?: Array<ViewingControllerGetClickCampaignsThreadsEnum>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/viewing/click/campaigns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (instagram) {
                localVarQueryParameter['instagram'] = instagram;
            }

            if (youtube) {
                localVarQueryParameter['youtube'] = youtube;
            }

            if (facebook) {
                localVarQueryParameter['facebook'] = facebook;
            }

            if (threads) {
                localVarQueryParameter['threads'] = threads;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 뷰잉 lock time 조회
         * @param {string} userUuid 유저 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewingControllerGetViewingLockTime: async (userUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userUuid' is not null or undefined
            assertParamExists('viewingControllerGetViewingLockTime', 'userUuid', userUuid)
            const localVarPath = `/viewing/lock-time`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userUuid !== undefined) {
                localVarQueryParameter['userUuid'] = userUuid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewingControllerPpapppapppapp: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/viewing/ppapppapppapp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewingControllerPpapppapppappPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/viewing/ppapppapppapp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 클릭형 캠페인 참여 가능 상태 확인
         * @param {string} campaignUuid 클릭형 캠페인 uuid
         * @param {string} typeCode 타입 코드
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewingControllerPrepareClickCampaign: async (campaignUuid: string, typeCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignUuid' is not null or undefined
            assertParamExists('viewingControllerPrepareClickCampaign', 'campaignUuid', campaignUuid)
            // verify required parameter 'typeCode' is not null or undefined
            assertParamExists('viewingControllerPrepareClickCampaign', 'typeCode', typeCode)
            const localVarPath = `/viewing/click/campaigns/{campaignUuid}/prepare`
                .replace(`{${"campaignUuid"}}`, encodeURIComponent(String(campaignUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (typeCode !== undefined) {
                localVarQueryParameter['typeCode'] = typeCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 모두그램에서 호출: 뷰잉 적립 회수
         * @param {RetrieveViewingPointReqBodyDto} retrieveViewingPointReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewingControllerRetrieveViewingPoint: async (retrieveViewingPointReqBodyDto: RetrieveViewingPointReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'retrieveViewingPointReqBodyDto' is not null or undefined
            assertParamExists('viewingControllerRetrieveViewingPoint', 'retrieveViewingPointReqBodyDto', retrieveViewingPointReqBodyDto)
            const localVarPath = `/viewing/retrieve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(retrieveViewingPointReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 뷰잉 보안문자 인증
         * @param {VerifyCaptchaReqBodyDto} verifyCaptchaReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewingControllerVerifyCaptcha: async (verifyCaptchaReqBodyDto: VerifyCaptchaReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verifyCaptchaReqBodyDto' is not null or undefined
            assertParamExists('viewingControllerVerifyCaptcha', 'verifyCaptchaReqBodyDto', verifyCaptchaReqBodyDto)
            const localVarPath = `/viewing/captcha`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyCaptchaReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 클릭형 캠페인 참여 인증
         * @param {string} campaignUuid 클릭형 캠페인 uuid
         * @param {VerifyClickCampaignReqBodyDto} verifyClickCampaignReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewingControllerVerifyClickCampaign: async (campaignUuid: string, verifyClickCampaignReqBodyDto: VerifyClickCampaignReqBodyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignUuid' is not null or undefined
            assertParamExists('viewingControllerVerifyClickCampaign', 'campaignUuid', campaignUuid)
            // verify required parameter 'verifyClickCampaignReqBodyDto' is not null or undefined
            assertParamExists('viewingControllerVerifyClickCampaign', 'verifyClickCampaignReqBodyDto', verifyClickCampaignReqBodyDto)
            const localVarPath = `/viewing/click/campaigns/{campaignUuid}/verify`
                .replace(`{${"campaignUuid"}}`, encodeURIComponent(String(campaignUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyClickCampaignReqBodyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ViewingApi - functional programming interface
 * @export
 */
export const ViewingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ViewingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 모두그램에서 호출: 자동적립 / 뷰업플러스 뷰잉하기 
         * @param {string} campaignUuid 클릭형 캠페인 uuid
         * @param {ViewingClickCampaignReqBodyDto} viewingClickCampaignReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async viewingControllerAutoViewingClickCampaign(campaignUuid: string, viewingClickCampaignReqBodyDto: ViewingClickCampaignReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.viewingControllerAutoViewingClickCampaign(campaignUuid, viewingClickCampaignReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewingApi.viewingControllerAutoViewingClickCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 뷰잉 보안문자 이미지 생성
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async viewingControllerGetCaptcha(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.viewingControllerGetCaptcha(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewingApi.viewingControllerGetCaptcha']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 클릭형 캠페인 가져오기
         * @param {Array<ViewingControllerGetClickCampaignsInstagramEnum>} [instagram] 인스타그램 필터링 조건
         * @param {Array<ViewingControllerGetClickCampaignsYoutubeEnum>} [youtube] 유튜브 필터링 조건
         * @param {Array<ViewingControllerGetClickCampaignsFacebookEnum>} [facebook] 페이스북 필터링 조건
         * @param {Array<ViewingControllerGetClickCampaignsThreadsEnum>} [threads] 스레드 필터링 조건
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async viewingControllerGetClickCampaigns(instagram?: Array<ViewingControllerGetClickCampaignsInstagramEnum>, youtube?: Array<ViewingControllerGetClickCampaignsYoutubeEnum>, facebook?: Array<ViewingControllerGetClickCampaignsFacebookEnum>, threads?: Array<ViewingControllerGetClickCampaignsThreadsEnum>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetClickCampaignsOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.viewingControllerGetClickCampaigns(instagram, youtube, facebook, threads, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewingApi.viewingControllerGetClickCampaigns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 뷰잉 lock time 조회
         * @param {string} userUuid 유저 uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async viewingControllerGetViewingLockTime(userUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetViewingLockTimeOkResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.viewingControllerGetViewingLockTime(userUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewingApi.viewingControllerGetViewingLockTime']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async viewingControllerPpapppapppapp(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.viewingControllerPpapppapppapp(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewingApi.viewingControllerPpapppapppapp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async viewingControllerPpapppapppappPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.viewingControllerPpapppapppappPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewingApi.viewingControllerPpapppapppappPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 클릭형 캠페인 참여 가능 상태 확인
         * @param {string} campaignUuid 클릭형 캠페인 uuid
         * @param {string} typeCode 타입 코드
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async viewingControllerPrepareClickCampaign(campaignUuid: string, typeCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckClickCampaignPreparedOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.viewingControllerPrepareClickCampaign(campaignUuid, typeCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewingApi.viewingControllerPrepareClickCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 모두그램에서 호출: 뷰잉 적립 회수
         * @param {RetrieveViewingPointReqBodyDto} retrieveViewingPointReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async viewingControllerRetrieveViewingPoint(retrieveViewingPointReqBodyDto: RetrieveViewingPointReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.viewingControllerRetrieveViewingPoint(retrieveViewingPointReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewingApi.viewingControllerRetrieveViewingPoint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 뷰잉 보안문자 인증
         * @param {VerifyCaptchaReqBodyDto} verifyCaptchaReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async viewingControllerVerifyCaptcha(verifyCaptchaReqBodyDto: VerifyCaptchaReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.viewingControllerVerifyCaptcha(verifyCaptchaReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewingApi.viewingControllerVerifyCaptcha']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 클릭형 캠페인 참여 인증
         * @param {string} campaignUuid 클릭형 캠페인 uuid
         * @param {VerifyClickCampaignReqBodyDto} verifyClickCampaignReqBodyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async viewingControllerVerifyClickCampaign(campaignUuid: string, verifyClickCampaignReqBodyDto: VerifyClickCampaignReqBodyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerifyClickCampaignOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.viewingControllerVerifyClickCampaign(campaignUuid, verifyClickCampaignReqBodyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ViewingApi.viewingControllerVerifyClickCampaign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ViewingApi - factory interface
 * @export
 */
export const ViewingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ViewingApiFp(configuration)
    return {
        /**
         * 
         * @summary 모두그램에서 호출: 자동적립 / 뷰업플러스 뷰잉하기 
         * @param {ViewingApiViewingControllerAutoViewingClickCampaignRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewingControllerAutoViewingClickCampaign(requestParameters: ViewingApiViewingControllerAutoViewingClickCampaignRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.viewingControllerAutoViewingClickCampaign(requestParameters.campaignUuid, requestParameters.viewingClickCampaignReqBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 뷰잉 보안문자 이미지 생성
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewingControllerGetCaptcha(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.viewingControllerGetCaptcha(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 클릭형 캠페인 가져오기
         * @param {ViewingApiViewingControllerGetClickCampaignsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewingControllerGetClickCampaigns(requestParameters: ViewingApiViewingControllerGetClickCampaignsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetClickCampaignsOkDto> {
            return localVarFp.viewingControllerGetClickCampaigns(requestParameters.instagram, requestParameters.youtube, requestParameters.facebook, requestParameters.threads, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 뷰잉 lock time 조회
         * @param {ViewingApiViewingControllerGetViewingLockTimeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewingControllerGetViewingLockTime(requestParameters: ViewingApiViewingControllerGetViewingLockTimeRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetViewingLockTimeOkResponseDto> {
            return localVarFp.viewingControllerGetViewingLockTime(requestParameters.userUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewingControllerPpapppapppapp(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.viewingControllerPpapppapppapp(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewingControllerPpapppapppappPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.viewingControllerPpapppapppappPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 클릭형 캠페인 참여 가능 상태 확인
         * @param {ViewingApiViewingControllerPrepareClickCampaignRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewingControllerPrepareClickCampaign(requestParameters: ViewingApiViewingControllerPrepareClickCampaignRequest, options?: RawAxiosRequestConfig): AxiosPromise<CheckClickCampaignPreparedOkDto> {
            return localVarFp.viewingControllerPrepareClickCampaign(requestParameters.campaignUuid, requestParameters.typeCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 모두그램에서 호출: 뷰잉 적립 회수
         * @param {ViewingApiViewingControllerRetrieveViewingPointRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewingControllerRetrieveViewingPoint(requestParameters: ViewingApiViewingControllerRetrieveViewingPointRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.viewingControllerRetrieveViewingPoint(requestParameters.retrieveViewingPointReqBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 뷰잉 보안문자 인증
         * @param {ViewingApiViewingControllerVerifyCaptchaRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewingControllerVerifyCaptcha(requestParameters: ViewingApiViewingControllerVerifyCaptchaRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.viewingControllerVerifyCaptcha(requestParameters.verifyCaptchaReqBodyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 클릭형 캠페인 참여 인증
         * @param {ViewingApiViewingControllerVerifyClickCampaignRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewingControllerVerifyClickCampaign(requestParameters: ViewingApiViewingControllerVerifyClickCampaignRequest, options?: RawAxiosRequestConfig): AxiosPromise<VerifyClickCampaignOkDto> {
            return localVarFp.viewingControllerVerifyClickCampaign(requestParameters.campaignUuid, requestParameters.verifyClickCampaignReqBodyDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for viewingControllerAutoViewingClickCampaign operation in ViewingApi.
 * @export
 * @interface ViewingApiViewingControllerAutoViewingClickCampaignRequest
 */
export interface ViewingApiViewingControllerAutoViewingClickCampaignRequest {
    /**
     * 클릭형 캠페인 uuid
     * @type {string}
     * @memberof ViewingApiViewingControllerAutoViewingClickCampaign
     */
    readonly campaignUuid: string

    /**
     * 
     * @type {ViewingClickCampaignReqBodyDto}
     * @memberof ViewingApiViewingControllerAutoViewingClickCampaign
     */
    readonly viewingClickCampaignReqBodyDto: ViewingClickCampaignReqBodyDto
}

/**
 * Request parameters for viewingControllerGetClickCampaigns operation in ViewingApi.
 * @export
 * @interface ViewingApiViewingControllerGetClickCampaignsRequest
 */
export interface ViewingApiViewingControllerGetClickCampaignsRequest {
    /**
     * 인스타그램 필터링 조건
     * @type {Array<'follow' | 'like' | 'comment'>}
     * @memberof ViewingApiViewingControllerGetClickCampaigns
     */
    readonly instagram?: Array<ViewingControllerGetClickCampaignsInstagramEnum>

    /**
     * 유튜브 필터링 조건
     * @type {Array<'comment' | 'like' | 'subscribe'>}
     * @memberof ViewingApiViewingControllerGetClickCampaigns
     */
    readonly youtube?: Array<ViewingControllerGetClickCampaignsYoutubeEnum>

    /**
     * 페이스북 필터링 조건
     * @type {Array<'follow' | 'like' | 'pagelike' | 'comment'>}
     * @memberof ViewingApiViewingControllerGetClickCampaigns
     */
    readonly facebook?: Array<ViewingControllerGetClickCampaignsFacebookEnum>

    /**
     * 스레드 필터링 조건
     * @type {Array<'follow' | 'like' | 'comment'>}
     * @memberof ViewingApiViewingControllerGetClickCampaigns
     */
    readonly threads?: Array<ViewingControllerGetClickCampaignsThreadsEnum>
}

/**
 * Request parameters for viewingControllerGetViewingLockTime operation in ViewingApi.
 * @export
 * @interface ViewingApiViewingControllerGetViewingLockTimeRequest
 */
export interface ViewingApiViewingControllerGetViewingLockTimeRequest {
    /**
     * 유저 uuid
     * @type {string}
     * @memberof ViewingApiViewingControllerGetViewingLockTime
     */
    readonly userUuid: string
}

/**
 * Request parameters for viewingControllerPrepareClickCampaign operation in ViewingApi.
 * @export
 * @interface ViewingApiViewingControllerPrepareClickCampaignRequest
 */
export interface ViewingApiViewingControllerPrepareClickCampaignRequest {
    /**
     * 클릭형 캠페인 uuid
     * @type {string}
     * @memberof ViewingApiViewingControllerPrepareClickCampaign
     */
    readonly campaignUuid: string

    /**
     * 타입 코드
     * @type {string}
     * @memberof ViewingApiViewingControllerPrepareClickCampaign
     */
    readonly typeCode: string
}

/**
 * Request parameters for viewingControllerRetrieveViewingPoint operation in ViewingApi.
 * @export
 * @interface ViewingApiViewingControllerRetrieveViewingPointRequest
 */
export interface ViewingApiViewingControllerRetrieveViewingPointRequest {
    /**
     * 
     * @type {RetrieveViewingPointReqBodyDto}
     * @memberof ViewingApiViewingControllerRetrieveViewingPoint
     */
    readonly retrieveViewingPointReqBodyDto: RetrieveViewingPointReqBodyDto
}

/**
 * Request parameters for viewingControllerVerifyCaptcha operation in ViewingApi.
 * @export
 * @interface ViewingApiViewingControllerVerifyCaptchaRequest
 */
export interface ViewingApiViewingControllerVerifyCaptchaRequest {
    /**
     * 
     * @type {VerifyCaptchaReqBodyDto}
     * @memberof ViewingApiViewingControllerVerifyCaptcha
     */
    readonly verifyCaptchaReqBodyDto: VerifyCaptchaReqBodyDto
}

/**
 * Request parameters for viewingControllerVerifyClickCampaign operation in ViewingApi.
 * @export
 * @interface ViewingApiViewingControllerVerifyClickCampaignRequest
 */
export interface ViewingApiViewingControllerVerifyClickCampaignRequest {
    /**
     * 클릭형 캠페인 uuid
     * @type {string}
     * @memberof ViewingApiViewingControllerVerifyClickCampaign
     */
    readonly campaignUuid: string

    /**
     * 
     * @type {VerifyClickCampaignReqBodyDto}
     * @memberof ViewingApiViewingControllerVerifyClickCampaign
     */
    readonly verifyClickCampaignReqBodyDto: VerifyClickCampaignReqBodyDto
}

/**
 * ViewingApi - object-oriented interface
 * @export
 * @class ViewingApi
 * @extends {BaseAPI}
 */
export class ViewingApi extends BaseAPI {
    /**
     * 
     * @summary 모두그램에서 호출: 자동적립 / 뷰업플러스 뷰잉하기 
     * @param {ViewingApiViewingControllerAutoViewingClickCampaignRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewingApi
     */
    public viewingControllerAutoViewingClickCampaign(requestParameters: ViewingApiViewingControllerAutoViewingClickCampaignRequest, options?: RawAxiosRequestConfig) {
        return ViewingApiFp(this.configuration).viewingControllerAutoViewingClickCampaign(requestParameters.campaignUuid, requestParameters.viewingClickCampaignReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 뷰잉 보안문자 이미지 생성
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewingApi
     */
    public viewingControllerGetCaptcha(options?: RawAxiosRequestConfig) {
        return ViewingApiFp(this.configuration).viewingControllerGetCaptcha(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 클릭형 캠페인 가져오기
     * @param {ViewingApiViewingControllerGetClickCampaignsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewingApi
     */
    public viewingControllerGetClickCampaigns(requestParameters: ViewingApiViewingControllerGetClickCampaignsRequest = {}, options?: RawAxiosRequestConfig) {
        return ViewingApiFp(this.configuration).viewingControllerGetClickCampaigns(requestParameters.instagram, requestParameters.youtube, requestParameters.facebook, requestParameters.threads, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 뷰잉 lock time 조회
     * @param {ViewingApiViewingControllerGetViewingLockTimeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewingApi
     */
    public viewingControllerGetViewingLockTime(requestParameters: ViewingApiViewingControllerGetViewingLockTimeRequest, options?: RawAxiosRequestConfig) {
        return ViewingApiFp(this.configuration).viewingControllerGetViewingLockTime(requestParameters.userUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewingApi
     */
    public viewingControllerPpapppapppapp(options?: RawAxiosRequestConfig) {
        return ViewingApiFp(this.configuration).viewingControllerPpapppapppapp(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewingApi
     */
    public viewingControllerPpapppapppappPost(options?: RawAxiosRequestConfig) {
        return ViewingApiFp(this.configuration).viewingControllerPpapppapppappPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 클릭형 캠페인 참여 가능 상태 확인
     * @param {ViewingApiViewingControllerPrepareClickCampaignRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewingApi
     */
    public viewingControllerPrepareClickCampaign(requestParameters: ViewingApiViewingControllerPrepareClickCampaignRequest, options?: RawAxiosRequestConfig) {
        return ViewingApiFp(this.configuration).viewingControllerPrepareClickCampaign(requestParameters.campaignUuid, requestParameters.typeCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 모두그램에서 호출: 뷰잉 적립 회수
     * @param {ViewingApiViewingControllerRetrieveViewingPointRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewingApi
     */
    public viewingControllerRetrieveViewingPoint(requestParameters: ViewingApiViewingControllerRetrieveViewingPointRequest, options?: RawAxiosRequestConfig) {
        return ViewingApiFp(this.configuration).viewingControllerRetrieveViewingPoint(requestParameters.retrieveViewingPointReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 뷰잉 보안문자 인증
     * @param {ViewingApiViewingControllerVerifyCaptchaRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewingApi
     */
    public viewingControllerVerifyCaptcha(requestParameters: ViewingApiViewingControllerVerifyCaptchaRequest, options?: RawAxiosRequestConfig) {
        return ViewingApiFp(this.configuration).viewingControllerVerifyCaptcha(requestParameters.verifyCaptchaReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 클릭형 캠페인 참여 인증
     * @param {ViewingApiViewingControllerVerifyClickCampaignRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewingApi
     */
    public viewingControllerVerifyClickCampaign(requestParameters: ViewingApiViewingControllerVerifyClickCampaignRequest, options?: RawAxiosRequestConfig) {
        return ViewingApiFp(this.configuration).viewingControllerVerifyClickCampaign(requestParameters.campaignUuid, requestParameters.verifyClickCampaignReqBodyDto, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ViewingControllerGetClickCampaignsInstagramEnum = {
    Follow: 'follow',
    Like: 'like',
    Comment: 'comment'
} as const;
export type ViewingControllerGetClickCampaignsInstagramEnum = typeof ViewingControllerGetClickCampaignsInstagramEnum[keyof typeof ViewingControllerGetClickCampaignsInstagramEnum];
/**
 * @export
 */
export const ViewingControllerGetClickCampaignsYoutubeEnum = {
    Comment: 'comment',
    Like: 'like',
    Subscribe: 'subscribe'
} as const;
export type ViewingControllerGetClickCampaignsYoutubeEnum = typeof ViewingControllerGetClickCampaignsYoutubeEnum[keyof typeof ViewingControllerGetClickCampaignsYoutubeEnum];
/**
 * @export
 */
export const ViewingControllerGetClickCampaignsFacebookEnum = {
    Follow: 'follow',
    Like: 'like',
    Pagelike: 'pagelike',
    Comment: 'comment'
} as const;
export type ViewingControllerGetClickCampaignsFacebookEnum = typeof ViewingControllerGetClickCampaignsFacebookEnum[keyof typeof ViewingControllerGetClickCampaignsFacebookEnum];
/**
 * @export
 */
export const ViewingControllerGetClickCampaignsThreadsEnum = {
    Follow: 'follow',
    Like: 'like',
    Comment: 'comment'
} as const;
export type ViewingControllerGetClickCampaignsThreadsEnum = typeof ViewingControllerGetClickCampaignsThreadsEnum[keyof typeof ViewingControllerGetClickCampaignsThreadsEnum];
